import { Component } from 'react';

export interface ErrorBoundaryProps {
  fallback: (x: { error: Error; resetErrorBoundary: () => void }) => any;
  onReset?: () => void;
}

type State = {
  error?: Error;
};

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  State
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: undefined };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: any) {
    console.warn(error, info.componentStack);
  }

  resetError() {
    this.setState({ error: undefined });
    this.props.onReset?.();
  }

  render() {
    if (this.state.error) {
      return this.props.fallback({
        error: this.state.error,
        resetErrorBoundary: this.resetError.bind(this),
      });
    }

    return this.props.children;
  }
}
